import axios from "axios";
import { Configuration, OpenAIApi } from "openai";



export const githubContents = async (userName, pat, projectName) => {
  try {
    let branch = "appmodernization";
    const response = await axios.get(
      `https://api.github.com/repos/${userName}/${projectName}/contents`,
      {
        headers: {
          Authorization: `Bearer ${pat}`,
        },
      }
    );
    console.log("GitHub API response =", response);
    return response;
  } catch (error) {
    console.error("Error fetching folder structure:", error);
  }
};

export const fetchFileContents = async (pat, fileUrl) => {
  try {
    const response = await axios.get(fileUrl, {
      headers: {
        Authorization: `Bearer ${pat}`,
      },
    });
    //since the content response is encoded in base64
    let parts = response.data.name.split(".");
    
    let ext = parts[parts.length - 1];
    
    console.log(ext);
    return {
      content: atob(response.data.content),
      ext,
    };
  } catch (error) {
    console.error("Error fetching file contents:", error);
    throw error;
  }
};

export const pushCodeToGithub = async (userName, pat, projectName, filePath, code) => {
    
    try {
      const url = `https://api.github.com/repos/${userName}/${projectName}/contents/${filePath}`;
  
      const encodedContent = btoa(unescape(encodeURIComponent(code)));
  
      const response = await axios.put(
        url,
        {
          message: "Pushing code via API",
          content: encodedContent,
        },
        {
          headers: {
            Authorization: `Bearer ${pat}`,
          },
        }
      );
  
      console.log("Code pushed to GitHub:", response.data);
      // Handle any further actions or display success message

    } catch (error) {
      console.error("Error pushing code to GitHub:", error);
      // Handle error and display error message
    }
  };
  
